"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainEventSchema = void 0;
const zod_1 = require("zod");
const event_names_1 = require("./event-names");
const eventNameSchema = zod_1.z.custom((value) => typeof value === 'string' && event_names_1.EVENT_NAMES_TUPLE.includes(value), { message: 'Unknown event name' });
exports.DomainEventSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: eventNameSchema,
    occurredAt: zod_1.z.string().datetime({ offset: true }),
    projectId: zod_1.z.number().int().positive().nullable(),
    payload: zod_1.z.record(zod_1.z.unknown()).optional(),
});
//# sourceMappingURL=domain-event.schema.js.map